<template>
  <div>
    <el-card class="new-folder">
      <div slot="header"
           class="clearfix">
        <span>{{$t('personSkyDri.newFolder')}}</span>
      </div>
      <el-form ref="data"
               :model="data"
               status-icon
               label-width="100px"
               class="demo-ruleForm"
               :rules="rules">
        <el-form-item :label='$t("personSkyDri.name")'
                      prop="name">
          <el-input v-model="data.name" size="mini"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea"
                    :rows="3"
                    v-model="data.remark"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="btnmg">
        <el-button type="primary" size="mini"
                    @click="submitForm('data')">{{$t('personSkyDri.save')}}</el-button>
        <el-button size="mini" @click="resetForm('data')">{{$t('personSkyDri.cancel')}}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'newFolder',
  props: {
    modalInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      data: {
        name: '',
        remark: ''
      },
      parentFolder: '',
      parentFolderId: '',
      rules: {
        name: [
          { message: '请输入文件夹名', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // console.log(this.modalInfo)
    this.data.name = this.modalInfo.name
  },
  methods: {
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 上传新数据接口
          let self = this
          ApiService.person_doc.addNewFolder({
            name: self.data.name,
            remark: self.data.remark,
            id: '',
            userID: '',
            parentID: this.modalInfo.id,
            creator: this.modalInfo.creater || JSON.parse(localStorage.user).userId
          }).then(res => {
            if (res.code === 0) {
              this.$message({
                message: res.msg,
                type: 'success'
              })
              this.$store.commit('reloadFile', Math.random())
              this.$store.commit('closeModal', 'newFolder')
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              })
            }
          })
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    // 取消、关闭
    resetForm(formName) {
      if (formName) {
        this.$refs[formName].resetFields()
      }
      this.$store.commit('closeModal', 'newFolder')
    }
  }
}
</script>

<style lang="scss">
@import '../../common/css/color.scss';
.new-folder {
  width: 400px;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mind/newFolder.vue